import {
  GET_INVOICE,
  GET_INVOICE_SUCCESS,
  GET_INVOICE_ERROR,

  GET_INVOICE_LINEITEMS,
  GET_INVOICE_LINEITEMS_SUCCESS,
  GET_INVOICE_LINEITEMS_ERROR,   
  
  GET_INVOICE_BILLINGCONTACT,
  GET_INVOICE_BILLINGCONTACT_SUCCESS,
  GET_INVOICE_BILLINGCONTACT_ERROR, 
} from "../actions";

import EnumRecordTypes from "../../enums/enumRecordTypes";

const INIT_STATE = {
  invoiceId: null,
  invoice: null,
  invoiceDetailsError: "",
  invoiceActivitySuccess: "",
  recordList: {
    records: [],
    pagination: {
      pageNumber: 1,
      pageSize: 5,
      startIndex: 1,
      totalItemCount: 0,
      totalPages: 0,
    },
    selectedRecords: {},
    responseTime: null
  }, 
  billingContactId: null,
  billingContact: null, 
  billingContactError: null, 
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_INVOICE_LINEITEMS:
      return {
        ...state,
        loading: true,
        error: "",
        recordList: null,
        selectedRecordType:
          typeof action.payload.recordType === "string"
            ? getRecordType(action.payload.recordType)
            : action.payload.recordType,
        displayStatus: action.payload.displayStatus,
        pageNumber: action.payload.pageNumber,
        parentRecordId: action.payload.parentRecordId,
        selectedFilters: action.payload.selectedFilters,
        invoiceId: action.payload.invoiceId,
        profile: action.payload.profile,
        params: action.payload.params,
        hasUserAccount: action.payload.hasUserAccount ? action.payload.hasUserAccount : ""
      };
    case GET_INVOICE_LINEITEMS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        recordList: action.payload,
      };
    case GET_INVOICE_LINEITEMS_ERROR:
      const recordList = { ...state.recordList, records: [] };
      recordList.pagination = {
        ...recordList.pagination,
        totalItemCount: 0,
        totalPages: 0,
      };
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        recordList,
      };
    case GET_INVOICE:
      return {
        ...state,
        loading: true,
        invoiceId: action.payload.invoiceId,
        activityDetailsError: "",
      };
    case GET_INVOICE_SUCCESS:
      return {
        ...state,
        loading: false,
        invoiceDetailsError: "",
        invoice: action.payload.invoice
      };
    case GET_INVOICE_ERROR:
      return { ...state, loading: false, invoiceDetailsError: action.payload ? action.payload.message : "" };
    
    case GET_INVOICE_BILLINGCONTACT:
        return { ...state, loading: true, billingContactId: action.payload.billingContactId};
    case GET_INVOICE_BILLINGCONTACT_SUCCESS:
        return { ...state, loading: false, billingContactError: "", billingContact: action.payload.contact };
    case GET_INVOICE_BILLINGCONTACT_ERROR:
        return { ...state, loading: false, billingContactError: action.payload ? action.payload.message : "" };
      
  
    default:
      return { ...state };
  }
};

const getRecordType = (recordTypeString) => {
  let recordTypeValue = EnumRecordTypes.Person;
  for (const key in EnumRecordTypes) {
    if (key.toLowerCase() === recordTypeString.toLowerCase()) {
      recordTypeValue = EnumRecordTypes[key];
      break;
    }
  }
  return recordTypeValue;
};